import { Component, OnInit, AfterViewInit, AfterContentChecked, AfterContentInit } from '@angular/core';
import { JobsService, Salary, SalaryType, Job } from 'src/app/services/jobs/jobs.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { LocationsService, JobLocation } from 'src/app/services/locations/locations.service';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent implements OnInit {

  filteredJobs: Job[];
  searchForm: FormGroup;

  constructor(private locationService: LocationsService, public js: JobsService, private fb: FormBuilder) { }

  ngOnInit(): void {
    window.scroll(0, 0);


    this.filteredJobs = this.js.jobs;
    this.searchForm = this.fb.group({
      location: '',
      keyword: ''
    });
  }
  displaySalary(salary: Salary) {
    switch (salary.type) {
      case SalaryType.FIXED:
        return SalaryType.toCurrency(salary.value);
      case SalaryType.RANGE:
        return SalaryType.toCurrency(salary.from) + ' - ' + SalaryType.toCurrency(salary.to);
      case SalaryType.MARKET:
        return 'Market related';
      case SalaryType.NEGOTIABLE:
        return 'Salary Negotiable';
      case SalaryType.HIDE:
      default:
        return '';
    }
  }
  search() {
    const jobKeyword = this.searchForm.controls.keyword.value.toString().toLowerCase().trim();
    const jobLocation = this.searchForm.controls.location.value.toString().toLowerCase().trim();
    if (jobKeyword === '' && jobLocation === '') {
      this.filteredJobs = this.js.jobs;
      return;
    }
    this.filteredJobs = this.js.jobs.filter((job: Job) => {
      if (job.title.toString().toLowerCase().trim().indexOf(jobKeyword) >= 0) {
        return true;
      }
      if (job.description.toString().toLowerCase().trim().indexOf(jobKeyword) >= 0) {
        return true;
      }
      if (job.location.name.toString().toLowerCase().trim().indexOf(jobKeyword) >= 0) {
        return true;
      }
      return false;
    });
  }

  filterLocations() {
    if (this.locationService.locations === undefined || this.locationService.locations === null) {
      return [];
    }
    const searchString = (this.searchForm.controls.location.value.toString() as string).toLowerCase().trim();
    const filtered = this.locationService.locations.filter(jobLocation => {
      return jobLocation.name.toLowerCase().indexOf(searchString) >= 0 ? 1 : 0;
    });
    return filtered;
  }
  getParent(parentId: number) {
   
    for (const parent of this.locationService.locations) {
      if (parent.id === parentId) {
        return `, ${parent.name}`;
      }
    }
    return '';
  }
  showName(jl: JobLocation) {
    return jl.name;
  }

}
